import { createContext } from "react";

export const TrainingContext = createContext();
